module.exports = __webpack_public_path__ + "img/X-Twitter-Logo--Streamline-Logos-Block.7cccc0c8.svg";